import { render } from "./B2CHeader.vue?vue&type=template&id=15d7b64d&lang=pug"
import script from "./B2CHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CHeader.vue?vue&type=script&setup=true&lang=js"

import "./B2CHeader.vue?vue&type=style&index=0&id=15d7b64d&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__